// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --navbar-Height: 80px;

  --bg-primary-Clr: #f25d2c;
  --bg-primary-clr: #1e4f6c;
  --text-primary-clr: #1e4f6c;
  --text-secondary-clr: #f25d2c;
  --text-black-Clr: #050505;
  --btn-primary-clr: #f25d2c;
  --btn-primary-HOVER: #d64717;
  --btn-secondary-clr: #1e4f6c;
  --btn-secondary-HOVER: #134664;
  --paragraph-font-size: 15px;
  --heading1-size: 4rem;
  --heading2-size: 3rem;
}

.form-control {
  width: 100%;
  height: auto;
}

.form-control form {
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
}
input {
  margin-bottom: 10px;
}
.form-control textarea {
  margin-bottom: 10px;
}

.form-control input,
.form-control select,
.form-control textarea {
  border: none;
  height: 40px;
  padding: 10px;
  outline: none;
  text-decoration: none;
  box-sizing: border-box;
  border-radius: 5px;
}
.form-input {
  max-width: 100%;
}
.form-names input,
.form-control select,
.form-control textarea {
  text-transform: capitalize;
}
.form-names {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
}
.f-name {
  width: 100% !important;
  gap: 5px;
}

.form-control textarea {
  height: 70px;
}
.form-control p {
  font-size: 12px;
  color: var(--btn-primary-clr);
}

input[type="submit"] {
  text-align: center;
  width: 30%;
  height: 50px;
  font-size: 20px;
  font-weight: 500;
  background-color: var(--btn-primary-clr);
  color: white;
  border-radius: 10px;
  cursor: pointer;
}

.f-name,
.l-name {
  display: flex;
  flex-direction: column;
  width: 100%;
}

input[type="submit"]:hover {
  font-weight: 500;
  background-color: white;
  color: var(--bg-primary-Clr);
  box-shadow: 1.6px 3.3px 5.3px rgba(0, 0, 0, 0.077),
    5.4px 11.2px 17.9px rgba(0, 0, 0, 0.113), 24px 50px 80px rgba(0, 0, 0, 0.19);
}

/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width: 1023px) {
  .form-control form {
    display: flex;
    flex-direction: column;
  }
  input {
    margin-bottom: 10px;
  }
  .form-control textarea {
    margin-bottom: 10px;
  }
}

/* Responsive For Tablet Screen size 601px to 1023px END */

/* Responsive For Mobile Screen size 1024px to 1920px START */
@media (max-width: 767px) {
  .form-names {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .f-name,
  .l-name {
    width: 100% !important;
  }

  input[type="submit"] {
    width: 100%;
    height: 50px;
  }
  input {
    margin-bottom: 10px;
  }
  .form-control textarea{
    margin-bottom: 10px;
  }
}

/* Responsive For Mobile Screen size 1024px to 1920px END */
`, "",{"version":3,"sources":["webpack://./src/Components/FooterformStyles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;;EAErB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B;gFAC8E;AAChF;;AAEA,4DAA4D;AAC5D;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,0DAA0D;;AAE1D,6DAA6D;AAC7D;EACE;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;EACA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,2DAA2D","sourcesContent":[":root {\n  --navbar-Height: 80px;\n\n  --bg-primary-Clr: #f25d2c;\n  --bg-primary-clr: #1e4f6c;\n  --text-primary-clr: #1e4f6c;\n  --text-secondary-clr: #f25d2c;\n  --text-black-Clr: #050505;\n  --btn-primary-clr: #f25d2c;\n  --btn-primary-HOVER: #d64717;\n  --btn-secondary-clr: #1e4f6c;\n  --btn-secondary-HOVER: #134664;\n  --paragraph-font-size: 15px;\n  --heading1-size: 4rem;\n  --heading2-size: 3rem;\n}\n\n.form-control {\n  width: 100%;\n  height: auto;\n}\n\n.form-control form {\n  display: flex;\n  flex-direction: column;\n  /* gap: 10px; */\n}\ninput {\n  margin-bottom: 10px;\n}\n.form-control textarea {\n  margin-bottom: 10px;\n}\n\n.form-control input,\n.form-control select,\n.form-control textarea {\n  border: none;\n  height: 40px;\n  padding: 10px;\n  outline: none;\n  text-decoration: none;\n  box-sizing: border-box;\n  border-radius: 5px;\n}\n.form-input {\n  max-width: 100%;\n}\n.form-names input,\n.form-control select,\n.form-control textarea {\n  text-transform: capitalize;\n}\n.form-names {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: space-between;\n}\n.f-name {\n  width: 100% !important;\n  gap: 5px;\n}\n\n.form-control textarea {\n  height: 70px;\n}\n.form-control p {\n  font-size: 12px;\n  color: var(--btn-primary-clr);\n}\n\ninput[type=\"submit\"] {\n  text-align: center;\n  width: 30%;\n  height: 50px;\n  font-size: 20px;\n  font-weight: 500;\n  background-color: var(--btn-primary-clr);\n  color: white;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.f-name,\n.l-name {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\ninput[type=\"submit\"]:hover {\n  font-weight: 500;\n  background-color: white;\n  color: var(--bg-primary-Clr);\n  box-shadow: 1.6px 3.3px 5.3px rgba(0, 0, 0, 0.077),\n    5.4px 11.2px 17.9px rgba(0, 0, 0, 0.113), 24px 50px 80px rgba(0, 0, 0, 0.19);\n}\n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width: 1023px) {\n  .form-control form {\n    display: flex;\n    flex-direction: column;\n  }\n  input {\n    margin-bottom: 10px;\n  }\n  .form-control textarea {\n    margin-bottom: 10px;\n  }\n}\n\n/* Responsive For Tablet Screen size 601px to 1023px END */\n\n/* Responsive For Mobile Screen size 1024px to 1920px START */\n@media (max-width: 767px) {\n  .form-names {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  .f-name,\n  .l-name {\n    width: 100% !important;\n  }\n\n  input[type=\"submit\"] {\n    width: 100%;\n    height: 50px;\n  }\n  input {\n    margin-bottom: 10px;\n  }\n  .form-control textarea{\n    margin-bottom: 10px;\n  }\n}\n\n/* Responsive For Mobile Screen size 1024px to 1920px END */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
